import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./index.css";

import banner1 from "../../assets/images/png/banner1.png";
import banner2 from "../../assets/images/png/banner2.png";
import banner3 from "../../assets/images/png/banner3.png";
import banner4 from "../../assets/images/png/banner4.png";
import banner5 from "../../assets/images/png/banner5.png";
// import banner6 from "../../assets/images/png/banner6.png";//halloween

const banners = [banner1, banner2, banner3, banner4, banner5];//, banner6];

export default function Banner() {
  const navigate = useNavigate();


  // comentado para remover o banner6 - halloween
  
  // const handleBannerClick = (index) => {
  //   if (index === 5) {
  //     // banner6 - redireciona para /halloween
  //     navigate("/halloween");
  //   }
  //   if (index === 3) {
  //     // banner2 is at index 1
  //     const element1 = document.querySelector(".scrollClawrranty1");
  //     if (element1) {
  //       element1.scrollIntoView({ behavior: "smooth" });
  //     }
  //     const element2 = document.querySelector(".scrollClawrranty2");
  //     if (element2) {
  //       element2.scrollIntoView({ behavior: "smooth" });
  //     }
  //   }
  //   if (index === 2) {
  //     const element3 = document.querySelector(".scrollClawrranty3");
  //     if (element3) {
  //       const elementPosition = element3.getBoundingClientRect().top;
  //       const offsetPosition = elementPosition + window.pageYOffset - 100;
  //       window.scrollTo({
  //         top: offsetPosition,
  //         behavior: "smooth",
  //       });
  //     }
  //   }
  // };

  return (
    <div className="banner-container">
      <Swiper
        pagination={{
          clickable: true,
        }}
        loop={true}
        navigation={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        modules={[Pagination, Navigation, Autoplay]}
        className="mySwiper"
      >
        {banners.map((banner, index) => (
          <SwiperSlide key={index}>
            <div style={{ paddingBottom: 40 }}>
              <img
                width="100%"
                src={banner}
                alt={`Banner ${index + 1}`}
                onClick={() => handleBannerClick(index)}
                style={{ cursor: "pointer" }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
